<template>
  <a-card :bordered='false'>
          <div class="m-b-20">
        <span>
          <a-button type="primary" v-has:orderReturnAddressCreate="()=>addAddress('add')">
            <PlusOutlined />
            新建退换货地址
          </a-button>
        </span>
      </div>
    <div class="s_flex_bian_c">
      <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
        :onFinish='pageSearchChange' layout='inline'>
          <!-- <a-form-item class='mb15' label="" name='keywords'>
     
        </a-form-item> -->
        <a-form-item label="关键词" name='keywords'>
               <!-- <a-input-group compact :style="{width:'360px'}">
            <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="order_no">收件人</a-select-option>
              <a-select-option value="user_id">联系方式</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword"  placeholder="请输入关键词进行搜索"/>
          </a-input-group> -->
          <a-input style="width: 300px;" v-model:value="search.keyword" placeholder="请输入收货人/联系方式" />
        </a-form-item>
             <a-form-item label="创建日期" name='time' >
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>

    </div>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list'>
      <template v-slot:name="{ record }">
        <a-tag v-if='record.is_default' color="#05486A">默认</a-tag>
        <span>{{record.name}}</span>
      </template>  
      <template v-slot:address="{ record }">
        <span>{{record.detail}}{{record.address}}</span>
      </template> 
      <template v-slot:action="{ record }">
         <a-button v-has:orderReturnEdit="()=>addAddress(record)" type="primary" class="m-r-10">编辑</a-button>
          <a-button v-has:orderReturnDel="()=>delAddress(record)" danger>删除</a-button>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
      :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" :show-total="total => `总数:${total} `" />
  </a-card>
  <a-modal  :keyboard="false" :title="type=='edit'?'编辑退换货地址':'添加退换货地址'" :width='900' centered :footer="null" v-model:visible="visible" destroyOnClose>
    <addressAdd v-on:onsubmit='onsubmit' :formData='formData'></addressAdd>
  </a-modal>
</template>
<script>
  import {  PlusOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getRouter } from "@/utils/app";
  import { setPageState, getPageState } from "@/utils/pageState";
  import { getAddressList, setaddressAdd, addressEdit, addressDel } from "@/api/order";
  import { iscode } from "@/utils/app";
  import addressAdd from './components/address_add';
  // 初始化默认筛选项数值
  let defSearch = {
    keyword: "",
    page: 1,
    limit: 10,
  };
  export default {
    components: {  PlusOutlined, addressAdd },
    name: 'levelList',
    setup(props, ctx) {
      // 列表数据和列头配置
      let list = ref([]);
      let search = ref({ ...defSearch });
      const state = reactive({
        visible: false,
        listLoading: false,
        time: [],
        total: 1,
        type:'add',
        formData:{}
      });
      let columns = [
        {
          title: "收货人",
          key: "name",
          slots: { customRender: "name" },
        },
        {
          title: "手机/电话",
          dataIndex: "phone",
          key: "phone",
        },
        {
          title: "退换货地址",
          key: "address",
          slots: { customRender: "address" },
        },
        {
          title: "创建日期",
          dataIndex: "create_time",
          key: "create_time",
        },
           {
          title: "类型",
          dataIndex: "remark",
          key: "remark",
          customRender:({record})=>{
            return  record.is_default==1?'默认地址':'-'
          }
        },
        {
          title: "操作",
          key: "action",
          slots: { customRender: "action" },
        },
      ];
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //添加/编辑
      const addAddress = (e) => {
        if (e == 'add') {
          state.visible = true
          state.formData = {}
          state.type = 'add'
        } else {
          state.visible = true
          state.formData = {
            id: e.id
          }
          state.type = 'edit'
        }
        console.log(state.type)
      }
      //删除代理商
      const delAddress = (e) => {
        if(list.value.length == 1){
          message.error('至少保留一条退换货地址！');
          return 
        }
        $Modal.confirm({
          centered:true,
          title:'地址删除',
          content: '删除后该地址将无法恢复，您确定要删除该地址吗？', onOk:async () => {
            let res = await addressDel({id:e.id}).then(res => res.data);
            if (iscode(res)) {
              message.success(res.msg);
              initData(search.value);
            }else {
              message.error(res.msg);
            }
          }
        })
      }
      const onsubmit = async (form) => {
        let res
        const hide = message.loading('正在加载中...', 0);
        console.log(state.type)
        if (state.type == 'add') {
          res = await setaddressAdd({...form,is_default:form.is_default ? 1 : 0}).then(res => res.data);
        } else {
          res = await addressEdit({...form,is_default:form.is_default ? 1 : 0}).then(res => res.data);
        }
        if (iscode(res)) {
          setTimeout(hide);
          message.success(res.msg);
          setTimeout(() => {
            state.visible = false
            initData(search.value);
            state.type == 'add'
          }, 1000);
        } else {
          setTimeout(hide);
          message.error(res.msg);
        }
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getAddressList(values).then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            list.value = res.data.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };


      onMounted(() => {
        // 查看是否有留存状态，有则替换
        initData(search.value);
      });
      const onChange=(e)=>{
      search.value.start_time = e[0]
      search.value.end_time = e[1]
      initData(search.value);
      }
      return {
        ...toRefs(state),
        search,
        list,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        delAddress,
        addAddress,
        onsubmit,
        onChange
      };
    },
  };
</script>